import { apiUrl } from "./api";

export const clearStoredTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('id_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user_email');
  localStorage.removeItem('user_name');
  localStorage.removeItem('auth_token');
  localStorage.removeItem('token_expires');
};

// Check authentication status from server
export const checkAuthStatus = async () => {
  try {
    const token = localStorage.getItem('auth_token');
    const headers = { 'Content-Type': 'application/json' };

    // Always send Bearer when present so /auth/status can apply user_logout_events to this JWT.
    // Session-only revalidation can miss a global logout recorded from another app (e.g. VMM).
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(apiUrl("/api/v1/auth/status"), {
      credentials: 'include', // Fallback for session-based auth
      headers
    });

    if (response.status === 401) {
      clearStoredTokens();
      return { authenticated: false };
    }

    if (response.ok) {
      const data = await response.json();
      return data; // Return full response including user data
    }
    return { authenticated: false };
  } catch {
    return { authenticated: false };
  }
};

export const getStoredUserEmail = () => {
  return localStorage.getItem('user_email') || '';
};
